import { eventsLogger } from './logging';
import { bookingActionsAdapter } from './booking';

export const preGaCustomMiddleware = [bookingActionsAdapter];

export const postGaCustomMiddleware = [eventsLogger];
